import { InjectionToken } from '@angular/core';
import { AgentGatewayContext } from './copilot.types';

/**
 * Supplies auth + identity headers for a request to the NestJS Agent Gateway.
 *
 * This is a token (not a direct `AuthService` dependency) on purpose: it keeps the copilot
 * chunk from statically importing `auth.service`, which sits in a pre-existing circular
 * dependency with the auth NGXS state. The concrete implementation lives in
 * `agent-gateway-auth.provider.ts` and is wired in `CopilotModule`.
 */
export interface AgentGatewayAuth {
  /**
   * Best-effort headers: an `Authorization` bearer/JWT for the current session plus
   * `x-td-user-id` / `x-td-company-id`. Never throws — returns whatever it can.
   */
  getAuthHeaders(context: AgentGatewayContext): Promise<Record<string, string>>;
}

export const AGENT_GATEWAY_AUTH = new InjectionToken<AgentGatewayAuth>('AGENT_GATEWAY_AUTH');
